module.exports = __webpack_public_path__ + "static/active-7c976887861952775ce9e57f70b41e97.jpg";